import styled from "styled-components";

export const Container = styled.div`
  border: solid 1px grey;
  border-radius: .3rem;
  margin-top: 1rem;
  padding: .25rem .5rem;
`